import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";
export type ListPriceTableMessages = {
  // COLUMNS MESSAGES
  codeColumn: string;
  titleColumn: string;
  eanColumn: string;
  variationColumn: string;
  priceColumn: string;
  promotionStartDateColumn: string;
  promotionFinalDateColumn: string;
  promotionPriceColumn: string;
  statusColumn: string;

  optionsColumn: string;
} & TableColumnsMessages;

export const LIST_PRICE_TABLE_MESSAGES: ListPriceTableMessages = {
  // COLUMNS MESSAGES
  codeColumn: "Código",
  titleColumn: "Título",
  eanColumn: "EAN",
  variationColumn: "Variação",
  priceColumn: "Preço",
  promotionStartDateColumn: "Início Promoção",
  promotionFinalDateColumn: "Fim Promoção",
  promotionPriceColumn: "Preço Promoção",
  statusColumn: "Status",

  ...TABLE_COLUMNS_MESSAGES,
};
